<template>
  <div>
    <pageHeader :headerIcon="'syringe'"
                :headerText="'Items'"
                :haveFilterInput="false">
    </pageHeader>

    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>

    <div style="padding-top: 25px;" v-else>
      <abstractTable :columns="itemsColumns" :data="computedItems"
                     :classes="'ui tablet very compact center aligned celled table'"
                     :dataPerPage="10" :paginationEnable="true"
                     :paginationNextButtonText="$t('next')"
                     :paginationFirstPageButtonText="$t('first')"
                     :paginationLastPageButtonText="$t('last')"
                     :paginationPervButtonText="$t('previous')" v-if="computedItems.length">

        <template slot="table-column">
          <th> {{ $t('actions') }} </th>
        </template>

        <template slot="table-row-after" slot-scope="props">
          <td style="width: 78px">
            <div class="ui blue very compact mini button" style="background-color: #092442"
                  @click="props.row.id.functionality()">
              {{ $t('show') }}
            </div>
          </td>
        </template>
      </abstractTable>

      <div v-else class="ui placeholder segment" style="margin-top: 30px; width: 100%">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No items have been added.
        </div>
        <div class="ui primary button" style="background-color: #092442"
             @click="navigateTo('New_Item')">
          Add Item
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      items: [],
      itemCategories: [],
      loading: true
    }
  },
  mounted () {
    this.$http.get('items', {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.items = response.data.items
      this.itemCategories = response.data.meta.categories
      this.loading = false
    })
  },
  computed: {
    itemsColumns () {
      return [
        { header: 'Name', fieldName: 'name', show: true },
        { header: 'Real Code', fieldName: 'real_code', show: true },
        { header: 'System Code', fieldName: 'system_code', show: true },
        { header: 'Quantity In Stock', fieldName: 'quantity_in_stock', show: true },
        { header: 'Unit Price', fieldName: 'unit_price', show: true },
        { header: 'Category', fieldName: 'category_name', show: true },
        { header: 'Unit Measurement', fieldName: 'unit_measurement', show: true },
        { header: 'Item Id', fieldName: 'id', show: false, html: false }
      ]
    },
    computedItems () {
      let formlatedItems = []

      let getCategory = categoryId => {
        return window._.find(this.itemCategories, itemCategory => {
          return itemCategory.id === categoryId
        })
      }

      window._.each(this.items, item => {
        let category = getCategory(item.item_category_id)
        formlatedItems.push({
          id: {
            functionality: () => {
              this.navigateTo('Show_Item', { key: 'params', value: { id: item.id } })
            },
            value: `<a style="cursor: pointer; text-decoration:underline;">${item.id}</a>`
          },
          name: item.name,
          real_code: item.real_code || '-',
          system_code: this.displaySystemCode(item.system_code),
          quantity_in_stock: item.quantity_in_stock,
          unit_price: item.recommanded_unit_price,
          category_name: category.name,
          unit_measurement: item.unit_measurement.name
        })
      })

      return window._.sortBy(formlatedItems, item => item.system_code)
    }
  },
  methods: {
    displaySystemCode (code) {
      if (code.length < 3) {
        return '0'.repeat(3 - code.length) + code
      }

      return code
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/inventory_system/items/Items.vue